import { ref, watch, computed, nextTick } from "vue";
import { uploadObjAndNotify } from "@/utils/cesium-common";
import { useStore } from "vuex";
import { ObjectType } from "@/models/objects/types";

export function useObjectPanel(objId) {
	const store = useStore();
	const isValid = ref(false);
	const form = ref(null); // templateのref='form'とマッピングする

	/** 更新対象のオブジェクトを取得しリアクティブに使用できるようにする */
	const obj = computed({
		get() {
			return store.state.object.objects.find((item) => item.id == objId);
		},
		set(newObj) {
			store.commit("updateObjInObjects", newObj);
		},
	});

	/** 透明度 */
	watch(
		() => obj.value.transparency,
		() => {
			if (obj.value.id === null) return;
			obj.value.updateTransparency();
		},
	);

	/** 色 */
	const updateColor = () => {
		if (obj.value.id === null) return;
		obj.value.updateMaterialSettings(true);
	};

	watch(
		[
			/** 色関連のプロパティが存在すれば監視する */
			() => obj.value.pathSettings?.surfaceColor,
			() => obj.value.fillSettings?.color,
			() => obj.value.cutSettings?.color,
			() => obj.value.surfaceSettings?.color,
		],
		() => {
			updateColor();
		},
	);

	return {
		obj,
		isValid,
		form,
	};
}
